/**
 * WatchingLine — one calm line per leg saying what TripMuscle is watching for
 * this traveller. Built from their price choice, the offers that apply and any
 * member price. A quiet guarantee, not an alert: muted text, no colour except
 * the small accent mark.
 */
import type { ReactNode } from "react";
import { Eye } from "lucide-react";
import type { PlanLeg } from "@/lib/types";
import { watchingLine } from "./fareLadderView";

interface WatchingLineProps {
  leg: Pick<PlanLeg, "priceChoice" | "offers" | "focus">;
  /** Sits at the end of the line, e.g. the "2 offers for this trip" link. */
  children?: ReactNode;
  /** Today as YYYY-MM-DD; injected for tests. */
  today?: string;
}

export default function WatchingLine({ leg, children, today }: WatchingLineProps) {
  const text = watchingLine({
    priceChoice: leg.priceChoice,
    focus: leg.focus,
    offers: leg.offers,
    memberPrice: leg.focus?.memberPrice ?? null,
    today,
  });
  if (!text) return null;
  return (
    <p className="flex items-start gap-1.5 text-xs text-muted-foreground print:hidden">
      <Eye className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[hsl(var(--primary))]" aria-hidden="true" />
      <span>
        {text}
        {children}
      </span>
    </p>
  );
}
